import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d8c56e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice" }
const _hoisted_2 = { class: "notice-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "notice-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统自动清理三个月前的已读通知", -1))
const _hoisted_6 = { class: "notice-list" }
const _hoisted_7 = { class: "type" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["notice-tabs-item", {
          active: index === _ctx.activeIndex
        }]),
          key: index,
          onClick: ($event: any) => (_ctx.activeIndex = index)
        }, _toDisplayString(item) + "(" + _toDisplayString(_ctx.total[index]) + ")", 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", {
        class: "notice-bar-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleReadAll && _ctx.handleReadAll(...args)))
      }, "全部标记已读")
    ]),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(["notice-list-item", {
          readed: item.isRead
        }])
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.code === 1 ? '实战' : '系统'), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(item.title), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(item.time), 1)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}